import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGearNewUi = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 23C14.4833 23 13.0833 22.6 11.8 21.8C10.5167 21 9.58333 19.9 9 18.5C9.58333 17.1 10.5167 16 11.8 15.2C13.0833 14.4 14.4833 14 16 14C17.5167 14 18.9167 14.4 20.2 15.2C21.4833 16 22.4167 17.1 23 18.5C22.4167 19.9 21.4833 21 20.2 21.8C18.9167 22.6 17.5167 23 16 23ZM16 21C16.95 21 17.8458 20.7833 18.6875 20.35C19.5292 19.9167 20.2167 19.3 20.75 18.5C20.2167 17.7 19.5292 17.0833 18.6875 16.65C17.8458 16.2167 16.95 16 16 16C15.05 16 14.1542 16.2167 13.3125 16.65C12.4708 17.0833 11.7833 17.7 11.25 18.5C11.7833 19.3 12.4708 19.9167 13.3125 20.35C14.1542 20.7833 15.05 21 16 21ZM16 20C15.5833 20 15.2292 19.8542 14.9375 19.5625C14.6458 19.2708 14.5 18.9167 14.5 18.5C14.5 18.0833 14.6458 17.7292 14.9375 17.4375C15.2292 17.1458 15.5833 17 16 17C16.4167 17 16.7708 17.1458 17.0625 17.4375C17.3542 17.7292 17.5 18.0833 17.5 18.5C17.5 18.9167 17.3542 19.2708 17.0625 19.5625C16.7708 19.8542 16.4167 20 16 20Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.35238 19.5H4V5.5H8V15.176C8.57856 14.5863 9.24627 14.0661 10 13.6188V5.5H14V12.1615C14.6511 12.054 15.3183 12 16 12V5.5H20V12.6786C20.6185 12.8997 21.219 13.1745 21.7998 13.5028C21.8672 13.5409 21.9339 13.5795 22 13.6187V5.5C22 4.39 21.11 3.5 20 3.5H4C2.89 3.5 2 4.39 2 5.5V19.5C2 20.61 2.9 21.5 4 21.5H7.69722C7.16189 20.8981 6.71264 20.2303 6.35238 19.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgGearNewUi);
export { ForwardRef as ReactComponent };
